/* src/app/shared/modal-dialogs/tutor-engagement/tutor-engagement.component.css */
.updateProgressSuccess {
  height: 100px;
  width: 100px;
}
/*# sourceMappingURL=tutor-engagement.component.css.map */
